import { Controller } from "@hotwired/stimulus"

// § 3.17 — video-platform picker. On the generic Meeting form the "fully
// automated" AI benefit banner sits below the picker and tracks it live:
//   - brandName targets show the selected platform's label
//   - the banner hides for Zoom / Microsoft Teams (external tools — no
//     ConsLog transcription/minutes pipeline runs there)
// The Pre-Bid modal and Bid-Closing form also mount this controller but
// wire no targets/actions and use a different select name, so everything
// here no-ops there (bidding module untouched).
export default class extends Controller {
  static targets = ["banner", "brandName"]

  AUTOMATED = ["daily_co", "google_meet"]

  connect() {
    const select = this.element.querySelector('select[name="meeting[meeting_provider]"]')
    if (select) this._apply(select)
  }

  changed(event) {
    this._apply(event.target)
  }

  _apply(select) {
    const slug = select.value
    const label = select.options[select.selectedIndex]?.text || "ConsLog Meetings"
    if (this.hasBannerTarget) {
      this.bannerTarget.classList.toggle("hidden", !this.AUTOMATED.includes(slug))
    }
    this.brandNameTargets.forEach((el) => { el.textContent = label })
  }
}
